import { Form, Input, Button, Flex } from "antd"
import { MailOutlined } from "@ant-design/icons"



const ForgotPasswordForm = () => {
  


  
  
    return (
    <>
      <Form.Item
        name="email"
        rules={[
          {
            type: 'email',
            message: 'The input is not valid E-mail!',
          },
          {
            required: true,
            message: 'Please input your E-mail!',
          },
        ]}
      >
        <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Username" />
      </Form.Item>

      <Flex justify="center" gap="large">
        <Button type="primary" htmlType="submit" >
          Send
        </Button>
      </Flex>
    </>
  )
}

export default ForgotPasswordForm;